import Watermark from "components/Watermark";
import GhgEmissionsSourceTable from "./GhgEmissionsSourceTable"
import GhgEmissionsGraph from "./GhgEmissionsGraph";
import * as ghgUtils from "./_utils";

export default function GhgEmissionsBySource({ ghgResults, title = "GHG emissions by source" }) {
    if (!ghgResults) return null;

    return (
        <>
            <div className="HeroPanel u-mt-md u-page-break u-print-border">
                <div className="HeroPanel-title">{title}</div>
                <div className="Grid-cell u-lg-width1of3">
                    <div className="Table u-pos-rel u-overflow-hidden">
                        <Watermark />
                        <GhgEmissionsSourceTable emissions={ghgResults.emissions.methane} gas={ghgUtils.gas.methane} />
                    </div>
                    <div className="Table u-pos-rel u-overflow-hidden">
                        <Watermark />
                        <GhgEmissionsSourceTable emissions={ghgResults.emissions.nitrousOxide} gas={ghgUtils.gas.nitrousOxide} />
                    </div>
                    <div className="Table u-page-break u-pos-rel u-overflow-hidden">
                        <Watermark />
                        <GhgEmissionsSourceTable emissions={ghgResults.emissions.carbonDioxide} gas={ghgUtils.gas.carbonDioxide} />
                    </div>
                </div>
                <div className="Grid-cell u-lg-width2of3 u-page-break">
                    <div style={{ paddingTop: "0px", paddingLeft: "30px" }} className="u-pos-rel u-overflow-hidden">
                        <div className="u-pt-lg">
                            <Watermark />
                            <GhgEmissionsGraph ghgResults={ghgResults} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
